import {
  Component,
  OnInit,
  Output,
  EventEmitter,
  Input,
  OnDestroy,
  OnChanges,
  SimpleChanges
} from '@angular/core';
import { Store } from '@ngxs/store';
import { Subject } from 'rxjs';
import { get } from 'lodash';
import { filter, takeUntil } from 'rxjs/operators';
import { WebsocketService, WebsocketUrl } from 'smartauction-frontend-micro-library';
import {
  BidItem,
  BidListService,
  BidListStatusCounts,
  OrganizationState,
  PaginationState,
  VDPConfigurationState
} from 'remarketing-angular-library';
import { TranslocoDirective } from '@jsverse/transloco';
import {
  BidlistUserDropdownComponent
} from './bidlist-user-dropdown/bidlist-user-dropdown.component';
import {
  BidlistStatusFilterComponent
} from './bidlist-status-filter/bidlist-status-filter.component';
import { BidlistSortSelectComponent } from './bidlist-sort-select/bidlist-sort-select.component';


@Component({
    selector: 'bidlist-filters',
    templateUrl: './bidlist-filters.component.html',
    styleUrls: ['./bidlist-filters.component.scss'],
    imports: [TranslocoDirective, BidlistUserDropdownComponent, BidlistStatusFilterComponent, BidlistSortSelectComponent]
})
export class BidlistFiltersComponent implements OnInit, OnChanges, OnDestroy {
  private destroyed$ = new Subject();

  @Input() bidlist: { items: BidItem[]; pagination: PaginationState };
  @Output() closed = new EventEmitter<boolean>();

  sortValue = 'most-relevant';
  isCollapsedStatus = true;
  bidListStatusCounts: BidListStatusCounts;

  constructor(
    private store: Store,
    private readonly bidListService: BidListService,
    private readonly websocketService: WebsocketService
  ) {}

  ngOnInit() {
    if (this.bidlist.pagination.metaData) {
      this.bidListStatusCounts = this.bidlist.pagination.metaData.bidlistStatusCounts;
    }

    let topics: string[];

    if (this.bidlist.items) {
      topics = this.bidlist.items.map(item => `${WebsocketUrl.AUCTION_ITEM}/${item.auctionItemUuid}`);
    }

    topics.push(`${WebsocketUrl.ORGANIZATION_ENTITY}/${this.getOeUuid()}`);

    this.websocketService
      .watchAll(...topics)
      .pipe(
        takeUntil(this.destroyed$),
        filter(payload => !!get(payload, 'purchaseType'))
      )
      .subscribe(() => this.refreshBidListStatusCounts());
  }

  ngOnChanges(changes: SimpleChanges): void {
    const { bidlist } = changes;
    if (bidlist && !bidlist.isFirstChange()) {
      this.refreshBidListStatusCounts();
    }
  }

  ngOnDestroy() {
    this.destroyed$.next(true);
    this.destroyed$.complete();
  }

  getFilterByBidListStatusValue(): string {
    const { bidListSort } = this.store.selectSnapshot(VDPConfigurationState.currentUserState);
    return bidListSort.bidListStatus;
  }

  getAddedByUuid(): string {
    const { bidListSort } = this.store.selectSnapshot(VDPConfigurationState.currentUserState);
    return bidListSort.addedByUuid;
  }

  getOeUuid(): string {
    return this.store.selectSnapshot(OrganizationState.oeUuid);
  }

  backClicked() {
    this.closed.emit();
  }

  toggleCollapsed() {
    this.isCollapsedStatus = !this.isCollapsedStatus;
  }

  isMobile(): boolean {
    return window.matchMedia('(max-width: 768px)').matches;
  }

  isCollapsed(): boolean {
    return this.isMobile() ? this.isCollapsedStatus : false;
  }

  refreshBidListStatusCounts() {
    this.bidListService
      .getBidListStatusCounts(this.getAddedByUuid())
      .pipe(takeUntil(this.destroyed$))
      .subscribe(counts => {
        this.bidListStatusCounts = counts;
      });
  }
}
